<template>
    <v-flex v-if="productsComplement.length">
        <v-carousel hide-delimiters>
            <v-carousel-item v-for="i in cantCarrousel" :key="i" style="width: 90%;margin: 0 auto;">
                <v-layout >
                    <v-flex sm=2 v-for="(p, j) in productsComplement[i-1]" :key="j" px-2>
                        <v-card elevation="0" light v-if="p.product_name_web!=''">
                            <img
                                :src="!!p.medium_image_url ? (urlApi+pathFileProducts+p.medium_image_url) : require('@/assets/ProductoSinImagen.jpg')"
                                style="width:100%;margin:0 auto;cursor:pointer;"
                                @click="redirectRelatedProduct(p.url_product)"
                                :alt="p.product_name_web" 
                            >
                            <div class='text-center' >
                                <div  class='grayblack--text font-title' style="height: 80px;" v-html=p.product_name_web> </div>
                                <v-btn 
                                    rounded 
                                    outlined 
                                    class='btn-quote-products font-title font-weight-black'
                                    @click="addItem(p)"
                                >
                                    COTIZAR
                                </v-btn>
                            </div>
                        </v-card>
                        <v-card light elevation="0" v-else>
                            <img :src="require('@/assets/blanco.png')" style="width:100%">
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-carousel-item>
        </v-carousel>
    </v-flex>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import Vue from 'vue'

export default {
    name:'LastProductsVisitedComponent',
    data:() =>({
        cantCarrousel:0,
        productsComplement:[],
        selectProduct:{
            product_id:null,
            quantity:0,
            product_name:'',
            images:[]
        },
    }),
    watch:{
        lastProductsVisited: function(){
            this.getLastProductsVisited()
        }
    },
    computed:{

        ...mapState(['lastProductsVisited','urlApi','pathFileProducts','selectedProducts','sweeAlertAddProduct']),
    },
    methods:{

        ...mapActions(['requestApi','dataCarousel']),

        ...mapMutations(['setLastProductsVisited','setUrl','setSelectedProducts','setTotalQuantity','itemShoppingCar']),

        getLastProductsVisited(){
      
            if(this.lastProductsVisited.length){
                this.setUrl('busqueda-catalogo')
                this.requestApi({
                    method: 'PATCH',
                    data :{
                        productsId:this.lastProductsVisited
                    }
                }).then(res =>{
                    
                    this.dataCarousel({
                        selectProduct: res.data._embedded.busqueda_catalogo,
                        width: this.$vuetify.breakpoint.width
                    }).then( res => {
                        console.log(res)
                        this.cantCarrousel = res.cantCarrousel
                        this.productsComplement = res.productsComplement
                    })

                })
            }

        },

        redirectRelatedProduct(product_id){
            location.href = `/medicamentos-especialidad/producto/${product_id}`
        },

        addItem(item){
          
            this.dialog=true
           
            let itemExist = this.selectedProducts.find(e => e.product_id == item.product_id)
            this.selectProduct.quantity=1
            this.selectProduct.product_id = item.product_id 
            
            if(typeof itemExist !='undefined'){

                let index = this.selectedProducts.indexOf(itemExist)
                this.selectProduct.quantity = this.selectedProducts[index].quantity

            }else{
                this.setSelectedProducts({
                    product_id: item.product_id,
                    internal_name: item.product_name_web,
                    quantity:1,
                    images: item.medium_image_url
                })
            }

            
            this.selectProduct.product_name= item.product_name_web
            this.selectProduct.images = item.medium_image_url
            let quantities = this.selectedProducts.map(obj=>{ return obj.quantity })
            this.setTotalQuantity(quantities.reduce((accumulator, currentValue) => accumulator + currentValue))
            this.itemShoppingCar(this.selectedProducts)
            Vue.swal({...this.sweeAlertAddProduct})
        },

    },
    created(){

        if(localStorage.getItem('lastProductsVisited')!='' && localStorage.getItem('lastProductsVisited')!= null){
            let products = JSON.parse(localStorage.getItem('lastProductsVisited'))
            this.setLastProductsVisited({product_id: products[0].product_id})   
        }
    
    }
}
</script>
<style scope>
    .v-window{
        /* height:380px!important; */
    }
</style>